"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneEventObj = exports.pxToRem = exports.remToPx = exports.toSentenceCase = exports.setWidthByStringLength = void 0;

var setWidthByStringLength = function setWidthByStringLength(string) {
  return Math.abs(string.length) * 0.6 + 1;
};

exports.setWidthByStringLength = setWidthByStringLength;

var toSentenceCase = function toSentenceCase(word) {
  return "".concat(word[0].toUpperCase()).concat(word.slice(1).toLowerCase());
};

exports.toSentenceCase = toSentenceCase;

var remToPx = function remToPx(rem, fontSize) {
  return rem * fontSize;
};

exports.remToPx = remToPx;

var pxToRem = function pxToRem(px, fontSize) {
  return px / fontSize;
};

exports.pxToRem = pxToRem;

var cloneEventObj = function cloneEventObj(eventObj) {
  var overrideObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  function EventCloneFactory(overProps) {
    for (var x in overProps) {
      this[x] = overProps[x];
    }
  }

  EventCloneFactory.prototype = eventObj;
  return new EventCloneFactory(overrideObj);
};

exports.cloneEventObj = cloneEventObj;